import * as yup from "yup";

export const schema = (t) => {
  return yup
    .object({
      code: yup
        .string()
        .required(
          t(
            "login.enterOtp.input.code.validations.emptyText",
            "Please enter a 6 digit code."
          )
        ),
    })
    .required();
};
